import React from 'react'
import { Form } from 'react-bootstrap'

const Topic = ({
    value = '',
    onChange = () => {}
}) => {

    return (
        <Form.Group>
            <Form.Label>Subject</Form.Label>
            <Form.Control
                type="text"
                value={value}
                onChange={e => onChange(e.target.value)}
            />
        </Form.Group>
    )
}

export default Topic
